import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTr: CultureInfo = {
  name: 'tr',
  displayName: 'Turkish',
  iso3LanguageCode: 'tur',
  iso2LanguageCode: 'tr',
  ietfLanguageTag: 'tr',
  parent: null
};
